import COAGroupApi from "./COAGroupApi";

export default COAGroupApi;